import { getAuth0Client } from '~auth';
import { getOfcExitUrl, isOfcAccess } from '~auth/ofcAccess';
import { resetTracking } from '~src/tracking';
import { clearHelpEmbedIdentities } from '~src/guide';
import { resetUserSession } from '~src/user';
import Swal from 'sweetalert2';

// Resolves `true` once the Parse session is revoked. On failure the user may
// retry the whole logout or stay signed in.
const revokeSession = async (retry) => {
  try {
    await resetUserSession({ revoke: true });
    return true;
  } catch {
    const result = await Swal.fire({
      icon: 'error',
      title: 'Logout non completato',
      text: 'Non è stato possibile revocare la sessione. Riprova.',
      confirmButtonText: 'Riprova',
      showCancelButton: true,
      cancelButtonText: 'Resta qui',
    });
    if (result.isConfirmed) await retry();
    return false;
  }
};

// «Esci» from an Argo access (PE-2215): the service-account session is revoked
// and the operator goes back to Argo, which records the exit. There is no
// Auth0 session to end.
const logoutOfcAccess = async () => {
  const exitUrl = getOfcExitUrl() || `${window.location.origin}/`;

  if (!(await revokeSession(logoutOfcAccess))) return;

  clearHelpEmbedIdentities();
  localStorage.clear();
  resetTracking();

  window.location.replace(exitUrl);
};

export const logoutRoute = async () => {
  if (isOfcAccess()) {
    return logoutOfcAccess();
  }

  const auth0 = await getAuth0Client();

  const returnTo = `${window.location.origin}${process.env.ROUTE_LOGIN}`;

  if (!(await revokeSession(logoutRoute))) return;

  clearHelpEmbedIdentities();
  localStorage.clear();

  auth0.logout({
    returnTo: returnTo,
  });

  resetTracking();
};
